import React from 'react';

const styles: Record<string, React.CSSProperties> = {
	main: {
		maxWidth: 896, // ~max-w-4xl
		margin: '0 auto',
		padding: '40px 16px',
	},
	h1: {
		marginBottom: 32,
		fontSize: 24,
		fontWeight: 700,
	},
	container: {
		fontSize: 14,
		lineHeight: 1.75,
		display: 'flex',
		flexDirection: 'column',
		gap: 40,
		wordBreak: 'keep-all',
	},
	section: {},
	h2: {
		marginBottom: 8,
		fontSize: 16,
		fontWeight: 600,
	},
	p: {
		marginTop: 0,
		marginBottom: 0,
	},
	mt2: {
		marginTop: 8,
	},
	mt3: {
		marginTop: 12,
	},
	list: {
		marginTop: 8,
		paddingLeft: 20,
		marginBottom: 0,
	},
	listItem: {
		marginTop: 4,
	},
	strong: {
		fontWeight: 700,
	},
};

const Privacy: React.FC = () => {
	return (
		<main style={styles.main}>
			<h1 style={styles.h1}>개인정보 처리방침</h1>

			<div style={styles.container}>
				<section style={styles.section}>
					<p style={styles.p}>
						&lt; 유스타터 &gt;(&apos;https://playstartup.net&apos;이하 &apos;플레이스타트업&apos;)는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을
						신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						본 개인정보처리방침은 <strong style={styles.strong}>2026년 6월 17일</strong>부터 적용됩니다.
					</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제1조 (개인정보의 처리 목적)</h2>
					<p style={styles.p}>
						&lt; 유스타터 &gt;(&apos;https://playstartup.net&apos;이하 &apos;플레이스타트업&apos;)는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의
						용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
					</p>
					<ul style={styles.list}>
						<li style={{ ...styles.listItem, marginTop: 10 }}>서비스 제공, 콘텐츠 제공, 맞춤서비스 제공을 목적으로 개인정보를 처리합니다.</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제2조 (개인정보의 처리 및 보유 기간)</h2>
					<p style={styles.p}>
						① &lt; 유스타터 &gt;는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>
							<strong style={styles.strong}>1. &lt;플레이스타트업 서비스 이용&gt;</strong>
						</li>
						<li style={styles.listItem}>
							개인정보는 수집·이용에 관한 동의일로부터 <strong style={styles.strong}>3년</strong>까지 위 이용목적을 위하여 보유·이용됩니다.
						</li>
						<li style={styles.listItem}>보유근거 : 유스타터는 기재된 개인정보의 처리 목적에 따라 사용자의 정보를 처리합니다.</li>
						<li style={styles.listItem}>관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년</li>
						<li style={styles.listItem}>예외사유 : -</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제3조 (개인정보의 제3자 제공)</h2>
					<p style={styles.p}>
						&lt; 유스타터 &gt;는 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에
						해당하는 경우에만 개인정보를 제3자에게 제공합니다.
					</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제4조 (개인정보처리 위탁)</h2>
					<p style={styles.p}>① &lt; 유스타터 &gt;는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						② 위탁계약 체결시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에
						관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제5조 (정보주체와 법정대리인의 권리·의무 및 그 행사방법)</h2>
					<p style={styles.p}>① 정보주체는 유스타터에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						② 제1항에 따른 권리 행사는 유스타터에 대해 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 유스타터는 이에 대해 지체 없이
						조치하겠습니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에
						따른 위임장을 제출하셔야 합니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						⑥ 유스타터는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
					</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제6조 (처리하는 개인정보의 항목)</h2>
					<p style={styles.p}>① &lt; 유스타터 &gt;는 다음의 개인정보 항목을 처리하고 있습니다.</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>필수항목 : 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보</li>
						<li style={styles.listItem}>선택항목 : -</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제7조 (개인정보의 파기)</h2>
					<p style={styles.p}>① &lt; 유스타터 &gt;는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>② 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>1. 파기절차 : 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>2. 파기방법</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</li>
						<li style={styles.listItem}>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제8조 (개인정보의 안전성 확보 조치)</h2>
					<p style={styles.p}>&lt; 유스타터 &gt;(&apos;플레이스타트업&apos;)는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>정기적인 자체 감사 실시(분기 1회)</li>
						<li style={styles.listItem}>개인정보 취급 직원의 최소화 및 교육</li>
						<li style={styles.listItem}>내부관리계획의 수립 및 시행</li>
						<li style={styles.listItem}>해킹 등에 대비한 기술적 대책(보안프로그램 설치 및 점검, 접근통제 등)</li>
						<li style={styles.listItem}>개인정보의 암호화</li>
						<li style={styles.listItem}>접속기록의 보관 및 위변조 방지(최소 1년 이상)</li>
						<li style={styles.listItem}>개인정보에 대한 접근 제한</li>
						<li style={styles.listItem}>문서보안을 위한 잠금장치 사용</li>
						<li style={styles.listItem}>비인가자에 대한 출입 통제</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
					<p style={styles.p}>① 유스타터 는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						② 쿠키는 웹사이트를 운영하는데 이용되는 서버(https)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>가. 쿠키의 사용 목적 : 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						나. 쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구&gt;인터넷 옵션&gt;개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제10조 (개인정보 보호책임자)</h2>
					<p style={styles.p}>
						① 유스타터 는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고
						있습니다.
					</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>
							<strong style={styles.strong}>▶ 개인정보 보호책임자</strong>
						</li>
						<li style={styles.listItem}>성명 : 최민중</li>
						<li style={styles.listItem}>직책 : CTO</li>
						<li style={styles.listItem}>직급 : -</li>
						<li style={styles.listItem}>연락처 : help@youstarter.co.kr</li>
					</ul>
					<p style={{ ...styles.p, ...styles.mt2 }}>※ 개인정보 보호 담당부서로 연결됩니다.</p>
					<ul style={{ ...styles.list, ...styles.mt2 }}>
						<li style={styles.listItem}>
							<strong style={styles.strong}>▶ 개인정보 보호 담당부서</strong>
						</li>
						<li style={styles.listItem}>부서명 : 기술개발팀</li>
						<li style={styles.listItem}>담당자 : 최민중</li>
						<li style={styles.listItem}>연락처 : help@youstarter.co.kr</li>
					</ul>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						② 정보주체께서는 유스타터 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로
						문의하실 수 있습니다. 유스타터 는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
					</p>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제11조 (개인정보 열람청구)</h2>
					<p style={styles.p}>
						정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. &lt; 유스타터 &gt;는 정보주체의 개인정보 열람청구가 신속하게 처리되도록
						노력하겠습니다.
					</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>
							<strong style={styles.strong}>▶ 개인정보 열람청구 접수·처리 부서</strong>
						</li>
						<li style={styles.listItem}>부서명 : 기술개발팀</li>
						<li style={styles.listItem}>담당자 : 최민중</li>
						<li style={styles.listItem}>연락처 : help@youstarter.co.kr</li>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제12조 (권익침해 구제방법)</h2>
					<p style={styles.p}>
						정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타
						개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
					</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)</li>
						<li style={styles.listItem}>개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
						<li style={styles.listItem}>대검찰청 : (국번없이) 1301 (www.spo.go.kr)</li>
						<li style={styles.listItem}>경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)</li>
					</ul>
					<p style={{ ...styles.p, ...styles.mt2 }}>
						「개인정보보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로
						인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.</p>
				</section>
				<section style={styles.section}>
					<h2 style={styles.h2}>제13조 (계정 삭제 관련 사항)</h2>
					<p style={styles.p}>유스타터는 정보주체가 계정 삭제를 요청할 경우 개인정보 보호책임자의 승인을 받아 계정을 삭제합니다.</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>정보주체는 개인정보 삭제를 원할 경우, 아래의 연락처를 통해 계정 및 개인정보 삭제를 요청할 수 있습니다.</li>
						<li style={styles.listItem}>삭제 요청이 접수되면 본인 확인 절차 후 즉시 계정이 삭제되며, 법령에 따라 보존이 필요한 경우를 제외한 모든 개인정보는 즉시 파기됩니다.</li>
						<li style={styles.listItem}>삭제된 계정 및 관련 데이터는 복구할 수 없습니다.</li>
						<li style={styles.listItem}>계정 삭제 관련 문의는 아래로 연락 주시기 바랍니다.</li>
						<ul style={styles.list}>
							<li style={styles.listItem}>부서명: 기술 개발팀</li>
							<li style={styles.listItem}>담당자: 최민중</li>
							<li style={styles.listItem}>연락처: help@youstarter.co.kr</li>
						</ul>
					</ul>
				</section>

				<section style={styles.section}>
					<h2 style={styles.h2}>제14조 (개인정보 처리방침 변경)</h2>
					<p style={styles.p}>
						① 이 개인정보처리방침은 <strong style={styles.strong}>2026년 6월 17일</strong>부터 적용됩니다.
					</p>
					<p style={{ ...styles.p, ...styles.mt2 }}>② 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</p>
					<ul style={styles.list}>
						<li style={styles.listItem}>2021. 10. 18 ~ 2026. 1. 15 : https://playstartup.net/privacy_v1</li>
						<li style={styles.listItem}>2026. 1. 16 ~ 2026. 6. 16 : https://playstartup.net/privacy_v2</li>
					</ul>
				</section>
			</div>
		</main>
	);
};

export default Privacy;
